import React, { Component } from "react";
import ItemsCarousel from "react-items-carousel";
import { connect } from "react-redux";
import { getFeaturedListings, getFeaturedListingsUsingID } from "./actions";
import {
  PHOTO_PLACEHOLDER,
  PIN_ICON,
  WHITE_ARROW_LEFT,
  WHITE_ARROW_RIGHT,
} from "../../constants/images";
import { PAGE_ROUTES } from "../../constants/pageRoutes";
import { MAGIC_NUMBER } from "../../constants/magicNumbers";

import ViewFeaturedListings from "../viewFeaturedListingsButton/component";
import { getListingImage, getNumberWithCommas } from "../../constants/util";

const mapStateToProps = (state) => ({
  featuredListings: state.BrowseListings.featuredListings,
});

export const renderCard = (l) => {
  const url = `/app/#${PAGE_ROUTES.LISTING}/${l._id}`;
  let imageURL = PHOTO_PLACEHOLDER;

  if (l.photos && l.photos.length) imageURL = getListingImage(l);

  const avgValue = l.streamId && l.pricing.average ? l.pricing.average : l.pricing.baseFee

  return (
    <a role="button" href={url}>
      <div className="card" key={l._id}>
        <div className="image-box">
          <img src={imageURL} className="card-image" alt="destination" />
          <div className="image-detail">
            <img src={PIN_ICON} className="pin-image" alt="pin" />
            <p className="university-detail">
              {l.address.city}, {l.address.state}
            </p>
          </div>
        </div>
        <div className="card-footer">
          <div className="about-listing">
            <p className="listing-info">{l.listingName}</p>
            <p className="items">
              {l.houseType} |{" "}
              {`${l.bedrooms} Bedroom${l.bedrooms === 1 ? "" : "s"}`}
            </p>
          </div>
          <div className="footer-box">
            <button type="button" className="btn secondary">
              ${getNumberWithCommas(Math.round(avgValue))}
              <span className="price"> avg/night</span> 
            </button>
          </div>
        </div>
      </div>
    </a>
  );
};

class FeaturedListingsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      carouselIndex: 0,
      carouselIntervalIndex: -1,
    };

    this.incrementCarouselIndex = this.incrementCarouselIndex.bind(this);
    this.retrieveListings = this.retrieveListings.bind(this);
    this.retrieveListingsUsingID = this.retrieveListingsUsingID.bind(this);
    this.setSlideInterval = this.setSlideInterval.bind(this);
    this.unSetSlideInterval = this.unSetSlideInterval.bind(this);
    this.getCardsToDisplay = this.getCardsToDisplay.bind(this);
  }

  componentDidMount() {
    const { isGrid } = this.props;
    if (isGrid) this.retrieveListings();
    else this.retrieveListingsUsingID();

    this.setSlideInterval();
  }

  componentWillUnmount() {
    this.unSetSlideInterval();
  }

  getCardsToDisplay = () => {
    const width = window.innerWidth;

    if (width <= 767) return 1;
    if (width > 767 && width <= 992) return 2;
    if (width > 992 && width <= 1139) return 3;

    return 4;
  };

  setSlideInterval = () => {
    const { isGrid } = this.props;

    if (isGrid) return;

    const intervalId = setInterval(() => {
      this.incrementCarouselIndex(1);
    }, MAGIC_NUMBER.FEATURED_LISTING_CHANGE_DELAY);

    this.setState({
      ...this.state,
      carouselIntervalIndex: intervalId,
    });
  };

  unSetSlideInterval = () => {
    const { isGrid } = this.props;

    if (isGrid) return;

    const { carouselIntervalIndex } = this.state;
    if (carouselIntervalIndex > 0) clearInterval(carouselIntervalIndex);
  };

  incrementCarouselIndex = (increment) => {
    const { featuredListings, isGrid } = this.props;
    if (featuredListings.length === 0 || isGrid) return;

    let carouselIndex = this.state.carouselIndex;
    const finalIndex = featuredListings.length - this.getCardsToDisplay();

    carouselIndex += increment;
    if (carouselIndex > finalIndex) carouselIndex = 0;
    if (carouselIndex < 0) carouselIndex = pageLength - 1;

    this.setState({
      ...this.state,
      carouselIndex: carouselIndex,
    });
  };

  retrieveListings = () => {
    const radius = document.getElementById("radius")
      ? document.getElementById("radius").value
      : MAGIC_NUMBER.DEFAULT_FEATURED_LISTING_RADIUS;
    const lat = document.getElementById("lat")
      ? document.getElementById("lat").value
      : MAGIC_NUMBER.DEFAULT_FEATURED_LISTING_LATITUDE;
    const long = document.getElementById("long")
      ? document.getElementById("long").value
      : MAGIC_NUMBER.DEFAULT_FEATURED_LISTING_LONGITUDE;
    if (radius && lat && long) {
      let data = {
        rad: Number(radius),
        lat: Number(lat),
        long: Number(long),
      };
      this.props.dispatch(getFeaturedListings(data));
    }
  };

  retrieveListingsUsingID = () => {
    if (typeof _CW_F_LIST_ !== "undefined")
      this.props.dispatch(getFeaturedListingsUsingID(_CW_F_LIST_));
  };

  render() {
    const { featuredListings, isGrid } = this.props;

    if (!featuredListings.length) {
      if (isGrid) return null;

      return (
        <div className="text-center w-100">
          There are currently no Featured Listings near your desired location.
          Please check back soon, as new listings are added frequently.
        </div>
      );
    }

    const message = !isGrid
      ? "Check out great rentals in college towns or explore options for your next college town road trip - you won't be disappointed!"
      : "The most popular rentals.";

    return (
      <div className="feature-listing-section">
        <div className="featured-head">
          <div className="head-left">
            <h2 className="featured-title">Featured Listings</h2>
            <h2 className="featured-pg">{message}</h2>
          </div>
          <div className="head-right">
            <ViewFeaturedListings />
            {!isGrid ? (
              <div className="listing-arrow">
                <button
                  className="listing-control-prev"
                  href="#"
                  role="button"
                  data-slide="prev"
                  onClick={() => {
                    this.incrementCarouselIndex(-1);
                  }}
                >
                  <span className="carousel-prev-icon" aria-hidden="true">
                    <img
                      src={WHITE_ARROW_LEFT}
                      alt="arrow"
                      className="arrow-img"
                    />
                  </span>
                  <span className="sr-only">Previous</span>
                </button>
                <button
                  className="listing-control-next"
                  href="#"
                  role="button"
                  data-slide="next"
                  onClick={() => {
                    this.incrementCarouselIndex(1);
                  }}
                >
                  <span className="carousel-next-icon" aria-hidden="true">
                    <img
                      src={WHITE_ARROW_RIGHT}
                      alt="arrow"
                      className="arrow-img"
                    />
                  </span>
                  <span className="sr-only">Next</span>
                </button>
              </div>
            ) : null}
          </div>
        </div>
        {!isGrid ? (
          <div
            className="featured-lisiting-carousel-section"
            id="feature-listing-id"
          >
            <ItemsCarousel
              requestToChangeActive={(index) => {
                this.setState({
                  ...this.state,
                  carouselIndex: index,
                });
              }}
              activeItemIndex={this.state.carouselIndex}
              slidesToScroll={1}
              numberOfCards={this.getCardsToDisplay()}
            >
              {featuredListings.map(renderCard)}
            </ItemsCarousel>
          </div>
        ) : (
          <div className="featured-lisiting-grid-section">
            <div className="card-section">
              {featuredListings.map(renderCard)}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(FeaturedListingsComponent);
